import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import { v4 as uuidv4 } from 'uuid';
const debug = process.env.REACT_APP_DEBUG && false;
export const getUserFromNormalData = (cognitoUser, nodeEdgeMapper) => {
    let user = undefined;
    if (cognitoUser && nodeEdgeMapper) {
        const userKey = `User:${cognitoUser.getSignInUserSession()?.getAccessToken().payload.sub}`;
        user = nodeEdgeMapper.getItem(getZombieInstanceFromPrimaryKey(userKey));
    }
    debug && console.log('getUserFromNormalData', user);
    return user;
};
export const getDefaultRouteFromNormalData = (normalData) => {
    // debug && console.log('getDefaultRouteFromNormalData', normalData)
    const map = new Map();
    const keys = ['Property', 'Field', 'Herd', 'Horse'];
    let path1 = '/THINGSVIEW/';
    let path2 = '';
    keys.map(key => {
        map.set(key, 0);
    });
    for (let key in normalData) {
        if (normalData.hasOwnProperty(key)) {
            const mapKey = !key.includes('_') && key.split(':')[0];
            if (typeof map.get(mapKey) !== 'undefined') {
                map.set(mapKey, map.get(mapKey) + 1);
            }
        }
    }
    for (var i = 0; i < keys.length; i++) {
        if (map.get(keys[i]) > 1) {
            path2 = keys[i];
            break;
        }
    }
    // if (!path2) path2 = 'Horse';
    if (path2 === 'Horse')
        return '/TABLEVIEW/Horse';
    debug && console.log('getDefaultRouteFromNormalData', path1, path2);
    return path1 + path2;
};
export const filterByUserProperty = (userData, children) => {
    const map = new Map();
    const keys = ['Horse', 'Herd', 'Field', 'Farrier', 'Property', 'Vet', 'Trainer', 'Groom'];
    keys.map(key => {
        map.set(key, 0);
    });
    for (let key in userData) {
        if (userData?.hasOwnProperty(key)) {
            const mapKey = !key.includes('_') && key.split(':')[0];
            if (typeof map.get(mapKey) !== 'undefined') {
                map.set(mapKey, map.get(mapKey) + 1);
            }
        }
    }
    const result = [];
    if (children) {
        for (var ind = 0; ind < children.length; ind++) {
            const key = children[ind].link?.split('/')[1];
            if (map.get(key) !== 0 && map.get(key) !== 1) {
                result.push(children[ind]);
            }
        }
    }
    debug && console.log('normalData', userData);
    debug && console.log('filterByUserProperty', result);
    return result;
};
export const addErrorToUpdate = (err, update) => {
    if (!(err.id && err.object)) {
        debug && console.log('Badly formed errors on ', err);
    }
    else {
        if (!update.errors)
            update.errors = {};
        if (!update.errors[err.object.sk]) {
            update.errors[err.object.sk] = { [err.id]: err };
        }
        else {
            update.errors[err.object.sk][err.id] = err;
        }
    }
    debug && console.log('addErrorToUpate', update.errors);
};
export const addMessageToUpdate = (update, label, content, type, severity) => {
    let message = {
        content,
        id: uuidv4(),
        label,
        type,
        severity,
    };
    if (!update.messages)
        update.messages = {};
    update.messages = { ...update.messages, [message.id]: message };
    debug && console.log(`Adding message to update ${content}`, update.messages);
};
